import React, { lazy, Suspense } from 'react';

// 懒加载组件
const Home = lazy(() => import('../pages/Home'));
const AboutUs = lazy(() => import('../pages/AboutUs'));
const ChooseUs = lazy(() => import('../pages/ChooseUs'));
const Partners = lazy(() => import('../pages/Partners'));
const HighSpeedHighPrecision = lazy(() => import('../pages/HighSpeedHighPrecision'));
const AdvancedMachineVision = lazy(() => import('../pages/AdvancedMachineVision'));
const SystemIntegration = lazy(() => import('../pages/SystemIntegration'));
const IntelligentSoftware = lazy(() => import('../pages/IntelligentSoftware'));
const ThreeC = lazy(() => import('../pages/ThreeC'));
const MedicalProducts = lazy(() => import('../pages/MedicalProducts'));
const CeramicComponents = lazy(() => import('../pages/CeramicComponents'));
const Semiconductor = lazy(() => import('../pages/Semiconductor'));
const ContactUs = lazy(() => import('../pages/ContactUs'));
const ThreeCProduct = lazy(() => import('../pages/ThreeCProduct'));
const MedicalProduct = lazy(() => import('../pages/MedicalProduct'));
const CeramicProduct = lazy(() => import('../pages/CeramicProduct'));
const SemiconductorProduct = lazy(() => import('../pages/SemiconductorProduct'));

// 加载中组件
const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '18px',
    color: '#236EF9'
  }}>
    加载中...
  </div>
);

// 懒加载包装器
const LazyComponent = ({ component: Component }) => (
  <Suspense fallback={<LoadingSpinner />}>
    <Component />
  </Suspense>
);

// 路由配置
export const routes = [
  { path: '/', component: () => <LazyComponent component={Home} />, title: 'Home' },
  { path: '/about', component: () => <LazyComponent component={AboutUs} />, title: 'About Us' },
  { path: '/choose-us', component: () => <LazyComponent component={ChooseUs} />, title: 'Choose Us' },
  { path: '/partners', component: () => <LazyComponent component={Partners} />, title: 'Partners' },
  { path: '/high-speed-high-precision', component: () => <LazyComponent component={HighSpeedHighPrecision} />, title: 'High Speed High Precision' },
  { path: '/advanced-machine-vision', component: () => <LazyComponent component={AdvancedMachineVision} />, title: 'Advanced Machine Vision' },
  { path: '/system-integration', component: () => <LazyComponent component={SystemIntegration} />, title: 'System Integration' },
  { path: '/intelligent-software', component: () => <LazyComponent component={IntelligentSoftware} />, title: 'Intelligent Software' },
  { path: '/3c', component: () => <LazyComponent component={ThreeC} />, title: '3C' },
  { path: '/medical-products', component: () => <LazyComponent component={MedicalProducts} />, title: 'Medical Products' },
  { path: '/ceramic-components', component: () => <LazyComponent component={CeramicComponents} />, title: 'Ceramic Components' },
  { path: '/semiconductor', component: () => <LazyComponent component={Semiconductor} />, title: 'Semiconductor' },
  { path: '/contact', component: () => <LazyComponent component={ContactUs} />, title: 'Contact Us' },
  { path: '/3c/:slug', component: () => <LazyComponent component={ThreeCProduct} />, title: '3C' },
  { path: '/medical-products/:slug', component: () => <LazyComponent component={MedicalProduct} />, title: 'Medical Products' },
  { path: '/ceramic-components/:slug', component: () => <LazyComponent component={CeramicProduct} />, title: 'Ceramic Components' },
  { path: '/semiconductor/:slug', component: () => <LazyComponent component={SemiconductorProduct} />, title: 'Semiconductor' },
];

// 路由映射函数
export const getPageComponent = (path) => {
  const route = routes.find(r => r.path === path);
  return route ? route.component : null;
};

// 获取页面标题
export const getPageTitle = (path) => {
  const route = routes.find(r => r.path === path);
  return route ? route.title : 'Heils';
};

